import styled from "styled-components";

export const StyledTitle = styled.h3`
    text-align: center;
    margin: -20px -20px 8px;
    padding: 12px 40px 10px;
`;
